import request from '../utils/request';

export function getUsers(params) {
    return request.get('/users', {params});
}

export function getUser(userId) {
    return request.get(`/users/${userId}`);
}

export function createUser(data) {
    return request.post(`/users`, data);
}

export function updateUser(userId, data) {
    return request.put(`/users/${userId}`, data);
}
export function updateProfile(data) {
    return request.put(`/profile`, data);
}

export function deleteUser(userId) {
    return request.delete(`/users/${userId}`);
}

export function resetTwoFactor() {
    return request.get(`/reset-two-factor`);
}

export function resetTwoFactorUser(userId) {
    return request.get(`/users/${userId}/resetTwoFactor`);
}
